import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';

import MapboxService from "./services/mapbox.service";

export default class MapboxProvider {
    #map = null
    constructor(options = {}) {
        this.mapParams = {
            container: 'mapbox',
            selector: '#mapbox',
            zoom: 16,
            minZoom: 5,
            maxZoom: 20,
            customAttribution: [
                '<a href="https://daylightmap.org/" target="_blank">DaylightMap</a>',
                'Building data - \
				<a href="https://github.com/microsoft/AustraliaBuildingFootprints/" target="_blank">Australia</a>, \
				<a href="https://github.com/microsoft/CanadianBuildingFootprints" target="_blank">Canada</a>, \
				<a href="https://github.com/microsoft/Uganda-Tanzania-Building-Footprints" target="_blank">Uganda/Tanzania</a>, \
				<a href="https://github.com/microsoft/USBuildingFootprints" target="_blank">US</a>'
            ],
            style: `/wp-content/assets/map-styles/map-style.json`,
            pitch: 10,
            bearing: 0,
            transformRequest: MapboxService.transformRequest,
            ...options
        }
    }

    init(customParams = {}) {
        this.#map = new mapboxgl.Map(this.mapParams)

        const params = {
            navigation: true,
            navigationOptions: { showCompass: true, visualizePitch: true, showZoom: true },
            ...customParams
        }

        if (params.navigation)
            this.#map.addControl(new mapboxgl.NavigationControl(params.navigationOptions), this.mapParams.control)
    }

    getMap() {
        return this.#map;
    }

    createMarker({ id, markerTemplate, coords }) {
        if (id && markerTemplate) markerTemplate.dataset.id = id
        if (markerTemplate) markerTemplate.classList.add('js-marker')

        const marker = new mapboxgl.Marker(markerTemplate).setLngLat(coords)
        if (id) marker.markerID = id.toString()

		return marker
	}

    addMarkerToMap(marker) {
		marker.addTo(this.#map)

		return marker
	}

    generateBounds(coords) {
        const bounds = new mapboxgl.LngLatBounds();
        coords.forEach( coordinates => {
            bounds.extend(coordinates);
        });
        return bounds;
    }

    fitBounds(bounds, {padding = 50} = {}) {
        this.#map.fitBounds(bounds, {padding});
    }

}
